import {SortingModelAbstract} from "@/models/SortingModelAbstract";
import {SORT_ARGS} from "@/app/exercise/modules/payments/core/models/OrdersConst";

export class OrdersSortingModel extends SortingModelAbstract {
  constructor(query) {
    super(SORT_ARGS);

    this.by = [];
    this.desc = [];
    this.ordering = null;
    this._apiAttributes = {
      payment_id: 'payment_id',
      plan__name: 'plan__name',
      paid_at: 'paid_at',
      expires_in: 'expires_in',
      deactivated_at: 'deactivated_at',
      is_active: 'is_active'
    };
    this._customSorting = {};
    this._orderingFields = {
      expires_in: 'expires_in',
      paid_at: 'paid_at',
      deactivated_at: 'deactivated_at',
      plan__name: 'plan__name',
      is_active: 'is_active'
    };
    this._initByQuery(query);
  }

}
